import { Link } from "@/i18n/navigation";
import { InquiryType } from "@/entities/inquiry/model/inquiry.type";

const PricingCardEnterprise = () => {
  return (
    <div
      className={
        "relative h-[612px] w-full rounded-lg border border-black px-[24px] pt-[28px] sm:w-[320px] sm:min-w-[320px]"
      }
    >
      <div>
        <div
          className={
            "flex h-[36px] w-[120px] items-center justify-center rounded-md bg-black text-title2 text-white"
          }
        >
          Enterprise
        </div>
        <div className={"mt-[6px] h-[56px] text-[10px] text-gray-400"}>
          회사 비즈니스 환경에 맞춘{" "}
          <span className={"font-[600] text-black"}>커스텀 AI 에이전트</span>가
          필요한 기업을 위한 요금제{" "}
        </div>
      </div>
      <div className={""}>
        <div className={"flex items-end justify-start"}>
          <div className={"text-heading3 font-[800] text-black"}>별도 문의</div>
        </div>
      </div>
      <div className={"mt-[32px]"}>
        <Link
          href={`/inquiry?pageType=${InquiryType.Enterprise}`}
          className={
            "flex h-[40px] w-full items-center justify-center rounded-md border border-black bg-white text-title2 text-black"
          }
        >
          도입 문의
        </Link>
      </div>
      <div className={"mt-[52px] w-full"}>
        <div
          className={
            "w-full rounded-xs border-[3px] border-dashed border-[#F84949] bg-[#FFF9F9] px-[12px] py-[7px] text-label2 font-[800] text-[#FF1B1B]"
          }
        >
          Pro 요금제의 모든 기능 +
        </div>
        <div className={"mt-[32px] w-full"}>
          <div
            className={
              "flex w-full items-center justify-start gap-[22px] text-primary"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#000000"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600] text-[#848484]"}>
              커스텀 AI 에이전트 제작
            </span>
          </div>
        </div>
        <div className={"mt-[12px] w-full"}>
          <div
            className={
              "flex w-full items-center justify-start gap-[22px] text-primary"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#000000"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600] text-[#848484]"}>
              업로드 문서 개인정보 보호 검토
            </span>
          </div>
        </div>
        <div className={"mt-[12px] w-full"}>
          <div
            className={
              "flex w-full items-center justify-start gap-[22px] text-primary"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#000000"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600] text-[#848484]"}>
              커스텀 챗봇 및 웹사이트 에디터 제공
            </span>
          </div>
        </div>
        <div className={"mt-[12px] w-full"}>
          <div
            className={
              "flex w-full items-center justify-start gap-[22px] text-primary"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#000000"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600] text-[#848484]"}>
              맞춤형 업무 특화 에이전트 추가
            </span>
          </div>
        </div>
      </div>
      <div className={"mt-[72px] w-full text-center font-[700] text-primary"}>
        <span className={"font-[900]"}>+</span> 전담 프리미엄 관리 지원
      </div>
    </div>
  );
};

export default PricingCardEnterprise;
